const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "2023第一场BOOOM游戏创作活动，来啦！"
const desc = "除了活动我们还有准备超多内容节目哦，等你来玩"

const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  data: {
    reviewLink:
      "https://www.taptap.cn/video/1952058/embed?thumb=https%3A%2F%2Fimg2.tapimg.com%2Fbbcode%2Fimages%2F016cab6cae67c0c4e6da36028db3cced.png",
    enrollLink: "https://shimo.im/forms/m8AZMamRKEsVdVkb/fill ",
    publishingLink: "https://site.gcores.com/publishing",
    historyLink: "https://site.gcores.com/booom2022horror/games/",
    applicationLink: "https://www.gcores.com/dev_community/application",
    teamLink: "https://shimo.im/docs/rp3OMvjWarsRJJkm/ ",
    submitExampleLink: "https://shimo.im/docs/1d3aMKe4yNF5K3gO/",
    submitGameLink: "https://shimo.im/docs/1d3aMKe4yNF5K3gO/",
    preGamesLink: "https://site.gcores.com/booom2022horror/games/",
    feedbackLink: "https://www.gcores.com/topics/421",
  },
}
